<template>
  <header class="site-header" :class="{ 'site-header--scrolled': scrolled }">
    <div class="site-header__inner">
      <router-link to="/" class="site-header__logo-link" aria-label="The Island House home">
        <img src="../assets/img/logo.webp" alt="The Island House" class="site-header__logo" />
      </router-link>

      <nav class="site-header__nav" aria-label="Primary navigation">
        <router-link to="/">Home</router-link>
        <router-link to="/our-food">Our Food</router-link>
        <router-link to="/order">Order Online</router-link>
        <router-link to="/locations">Locations</router-link>
        <router-link to="/contact">Contact</router-link>
      </nav>

      <div class="site-header__actions">
        <router-link to="/order" class="brand-button brand-button--compact">Order Online <span>→</span></router-link>
        <button class="menu-toggle" @click="toggled = !toggled" :aria-expanded="toggled" aria-label="Toggle menu">
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>

    <div class="mobile-menu" :class="{ 'mobile-menu--open': toggled }">
      <router-link @click="toggled = false" to="/">Home</router-link>
      <router-link @click="toggled = false" to="/our-food">Our Food</router-link>
      <router-link @click="toggled = false" to="/order">Order Online</router-link>
      <router-link @click="toggled = false" to="/locations">Locations</router-link>
      <router-link @click="toggled = false" to="/contact">Contact</router-link>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return { toggled: false, scrolled: false }
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 20
    }
  }
}
</script>

<style scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 1000;
  padding: 20px 28px;
  transition: background .25s ease, padding .25s ease, box-shadow .25s ease;
}
.site-header--scrolled { background: rgba(7,7,7,.96); padding-top: 11px; padding-bottom: 11px; box-shadow: 0 8px 30px rgba(0,0,0,.25); }
.site-header__inner { max-width: 1180px; margin: 0 auto; display:flex; align-items:center; justify-content:space-between; gap:30px; }
.site-header__logo { width:82px; height:82px; object-fit:contain; transition: width .2s ease, height .2s ease; }
.site-header--scrolled .site-header__logo { width:64px; height:64px; }
.site-header__nav { display:flex; align-items:center; gap:30px; margin-left:auto; }
.site-header__nav a { color:#fff; text-decoration:none; font-size:12px; font-weight:800; text-transform:uppercase; letter-spacing:.08em; position:relative; }
.site-header__nav a::after { content:""; position:absolute; height:2px; left:0; right:100%; bottom:-8px; background:var(--primary); transition:right .2s ease; }
.site-header__nav a:hover::after,.site-header__nav a.router-link-exact-active::after { right:0; }
.site-header__actions { display:flex; align-items:center; gap:12px; }
.menu-toggle { display:none; width:48px; height:48px; border:0; background:transparent; padding:10px; }
.menu-toggle span { display:block; height:2px; background:#fff; margin:6px 0; }
.mobile-menu { display:none; }
@media(max-width:900px){
  .site-header { padding:12px 18px; background:rgba(7,7,7,.96); }
  .site-header__logo,.site-header--scrolled .site-header__logo { width:68px; height:68px; }
  .site-header__nav { display:none; }
  .menu-toggle { display:block; }
  .site-header__actions .brand-button { display:none; }
  .mobile-menu { display:flex; position:absolute; top:92px; left:0; right:0; background:#090909; border-top:1px solid #292929; padding:18px; flex-direction:column; gap:4px; transform:translateY(-140%); opacity:0; pointer-events:none; transition:.25s ease; }
  .mobile-menu--open { transform:translateY(0); opacity:1; pointer-events:auto; }
  .mobile-menu a { color:#fff; text-decoration:none; text-transform:uppercase; font-weight:800; letter-spacing:.08em; padding:15px 8px; border-bottom:1px solid #202020; }
}
</style>
